var _path, _circle, _circle2, _path2, _path3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _line, _line2, _line3, _line4, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 140,
    r: 4,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 140,
    r: 4,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 158 Q200 166 208 158",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200 78 L203 88 L213 88 L205 94 L208 104 L200 98 L192 104 L195 94 L187 88 L197 88 Z",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 145,
    r: 18,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 145,
    r: 18,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 210,
    r: 15,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 210,
    r: 15,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 141,
    r: 3,
    fill: "#fafcfb",
    opacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 141,
    r: 3,
    fill: "#fafcfb",
    opacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 145,
    x2: 168,
    y2: 145,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 145,
    x2: 282,
    y2: 145,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 175,
    x2: 142,
    y2: 200,
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 175,
    x2: 258,
    y2: 200,
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 130,
    r: 50,
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.25,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaders);
export default __webpack_public_path__ + "static/media/leaders.bc92e08e38ed955641e037b071739633.svg";
export { ForwardRef as ReactComponent };